import { css } from "@emotion/css";

export const createTextAreaStyles = () => {
  return {
    textArea: css({
      resize: "vertical",
      minHeight: 83,
      maxHeight: 350,
    }),
    textAreaWrapper: css({
      height: "auto",
    }),
  };
};
